// Bilingual strings for the public OCIA payment-lookup page.

const en = {
  locale: 'en-US',
  languageLabel: { en: 'English', es: 'Español' },

  pageTitle: 'OCIA Payment',
  pageSubtitle: 'Enter your email to look up your OCIA registration and make a payment.',

  schoolYear: 'Year',
  noSchoolYears: 'No years available',
  emailAddress: 'Email Address',
  lookUpRegistration: 'Look Up Registration',

  pleaseEnterEmail: 'Please enter your email address.',
  pleaseEnterValidEmail: 'Please enter a valid email address.',
  noRegistrationsFound: (email, year) =>
    `No registrations found for ${email}${year ? ` in ${year}` : ''}.`,
  lookupFailed: 'Lookup failed. Please try again.',

  pleaseSelectRegistration: 'Please select a registration.',
  noRemainingBalance: 'This registration has no remaining balance.',
  lookUpDifferentEmail: 'Look up a different email',
  yourRegistration: 'Your Registration',
  selectRegistration: 'Select a Registration',

  paymentHistory: 'Payment History',
  date: 'Date',
  amount: 'Amount',
  method: 'Method',
  noPaymentsYet: 'No payments yet.',
  fullyPaid: 'Paid in Full',
  payBalanceButton: (bal) => `Pay Balance (${bal})`,

  schoolYearLabel: (year) => `Year: ${year || '—'}`,
  totalLabel: (amt) => `Total: ${amt}`,
  paidLabel: (amt) => `Paid: ${amt}`,
  paidInFull: 'Paid in Full',
  balanceLabel: (bal) => `Balance: ${bal}`,

  backToRegistration: 'Back to registration',
  makePayment: 'Make a Payment',
  balanceDue: (bal) => `Balance Due: ${bal}`,
  paymentAmountLabel: 'Payment Amount ($)',
  loadingPaymentForm: 'Loading payment form…',
  payButton: (amt) => `Pay ${amt}`,

  paymentSystemFailed: 'The payment system failed to load. Please refresh and try again.',
  pleaseEnterValidAmount: 'Please enter a valid payment amount.',
  paymentExceedsBalance: (bal) => `Payment cannot exceed the remaining balance of ${bal}.`,
  paymentFormNotReady: 'The payment form is not ready yet. Please wait a moment.',
  cardDetailsInvalid: 'Card details are invalid.',
  paymentSuccess: (paid, bal) => `Payment of ${paid} received. New balance: ${bal}.`,
  paymentFailed: 'Payment failed. Please try again.'
};

const es = {
  locale: 'es-US',
  languageLabel: { en: 'English', es: 'Español' },

  pageTitle: 'Pago de OCIA',
  pageSubtitle: 'Ingrese su correo electrónico para buscar su registro de OCIA y realizar un pago.',

  schoolYear: 'Año',
  noSchoolYears: 'No hay años disponibles',
  emailAddress: 'Correo electrónico',
  lookUpRegistration: 'Buscar registro',

  pleaseEnterEmail: 'Por favor ingrese su correo electrónico.',
  pleaseEnterValidEmail: 'Por favor ingrese un correo electrónico válido.',
  noRegistrationsFound: (email, year) =>
    `No se encontraron registros para ${email}${year ? ` en ${year}` : ''}.`,
  lookupFailed: 'La búsqueda falló. Por favor intente de nuevo.',

  pleaseSelectRegistration: 'Por favor seleccione un registro.',
  noRemainingBalance: 'Este registro no tiene saldo pendiente.',
  lookUpDifferentEmail: 'Buscar otro correo electrónico',
  yourRegistration: 'Su registro',
  selectRegistration: 'Seleccione un registro',

  paymentHistory: 'Historial de pagos',
  date: 'Fecha',
  amount: 'Monto',
  method: 'Método',
  noPaymentsYet: 'Aún no hay pagos.',
  fullyPaid: 'Pagado en su totalidad',
  payBalanceButton: (bal) => `Pagar saldo (${bal})`,

  schoolYearLabel: (year) => `Año: ${year || '—'}`,
  totalLabel: (amt) => `Total: ${amt}`,
  paidLabel: (amt) => `Pagado: ${amt}`,
  paidInFull: 'Pagado en su totalidad',
  balanceLabel: (bal) => `Saldo: ${bal}`,

  backToRegistration: 'Volver al registro',
  makePayment: 'Realizar un pago',
  balanceDue: (bal) => `Saldo pendiente: ${bal}`,
  paymentAmountLabel: 'Monto del pago ($)',
  loadingPaymentForm: 'Cargando formulario de pago…',
  payButton: (amt) => `Pagar ${amt}`,

  paymentSystemFailed: 'El sistema de pago no se pudo cargar. Actualice e intente de nuevo.',
  pleaseEnterValidAmount: 'Por favor ingrese un monto de pago válido.',
  paymentExceedsBalance: (bal) => `El pago no puede exceder el saldo pendiente de ${bal}.`,
  paymentFormNotReady: 'El formulario de pago aún no está listo. Espere un momento.',
  cardDetailsInvalid: 'Los datos de la tarjeta no son válidos.',
  paymentSuccess: (paid, bal) => `Pago de ${paid} recibido. Nuevo saldo: ${bal}.`,
  paymentFailed: 'El pago falló. Por favor intente de nuevo.'
};

export const translations = { en, es };
